import { href, Outlet } from 'react-router';

import { Box } from '@valwin/facto/components';
import { LockIcon } from '@valwin/facto/icons';

import { useUser } from '~entities/session';
import { UserRole } from '~entities/user';
import { type PharmacyRoute, ROUTES, usePharmacyId } from '~shared/routes';

import { AccessDenied } from './AccessDenied';

type RoleGuardProps = {
  allowedRoles: UserRole[];
  redirectTo?: PharmacyRoute;
};

export function RoleGuard({ allowedRoles, redirectTo }: RoleGuardProps) {
  const pharmacyId = usePharmacyId();
  const user = useUser(pharmacyId);

  if (!user || !allowedRoles.includes(user.role)) {
    return (
      <AccessDenied
        title="Accès restreint"
        message={
          <>
            <Box>
              Votre rôle ne vous permet pas d&apos;accéder à cette page.
            </Box>
            <Box>
              Contactez le titulaire de la pharmacie pour modifier vos droits.
            </Box>
          </>
        }
        icon={<LockIcon />}
        link={href(redirectTo ?? ROUTES.auth.login, { pharmacyId })}
      />
    );
  }

  return <Outlet />;
}
